import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error: '',
  error400: false,
  successFlag: false,
  token: '',
  patientMedicalHistory: null,
  allPatientMedicalHistory: [],
  errorStatus: null,
};
const getters = {
  getApiLoad_70: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  SET_Status(state, status) {
    state.successFlag = status;
  },
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_PatientMedicalHistory(state, patientMedicalHistories) {
    state.patientMedicalHistory = patientMedicalHistories;
  },
  SET_AllPatientMedicalHistory(state, patientMedicalHistories) {
    state.allPatientMedicalHistory = patientMedicalHistories;
  },
};
const actions = {
  errorPatientMedicalHistory({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getPatientMedicalHistoryById({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/PatientMedicalHistories/ById?patientId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PatientMedicalHistory', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatientMedicalHistory', error);
      });
  },
  getAllPatientMedicalHistory({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/PatientMedicalHistories/All?patientId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllPatientMedicalHistory', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatientMedicalHistory', error);
      });
  },
  addPatientMedicalHistory({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/PatientMedicalHistories', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatientMedicalHistory', error);
      });
  },
  deletePatientMedicalHistory({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/PatientMedicalHistories/Remove?patientMedicalHistoryId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatientMedicalHistory', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
